module.exports = __webpack_public_path__ + "img/access_unlock_open.ffb6944c.svg";